import { FC, PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import cls from './Container.module.scss';

type ContainerProps = {
  className?: string;
};

export const Container: FC<PropsWithChildren<ContainerProps>> = ({ children, className }) => {
  return <div className={clsx(cls.wrap, className)}>{children}</div>;
};
